export default __webpack_public_path__ + "static/YourEveryDay-64a730f3535b76c735376540ac3a1705.png";